/**
 * Created by yz on 2017/3/27.
 */
{
    angular.module('interfaceModule')
        .controller('PreviewController',PreviewController);
    PreviewController.$inject = ['$scope',"$state",'$stateParams','request.order',
    'utils.currentUser','utils.common',"request.file","utils.constant"];
    function PreviewController($scope,$state,$stateParams,orderRequest,
    	currentUser,common,fileRequest,constant) {
        let vm=this;
        let collect={
            'orderId':$stateParams.orderId,
            'printType':$stateParams.printType,
            'docInfo':null,
            'pageImages':[],
            'swiper':{},
            'previousPage':previousPage,
            'nextPage':nextPage,
            'onPageChanged':onPageChanged
        };
        vm.collect=collect;
        activate();

        function activate(){
        	// console.log($stateParams);
            
            getDocInfo(collect.orderId);
        }


        function getDocInfo(orderId){
            if(!orderId||orderId==""){
                common.loading.show();
                fileRequest.getUploadResult().then(function(data){
                    console.log(data);
                    common.loading.hide();
                    if(data.result==1){
                        collect.docInfo=data.fileData;
                        initPages(data.fileData.docId,data.fileData.pageNum, data.fileData.fileName);
                    }else{
                        common.prompt('读取文档信息失败！');
                    }
                    
                },function(data){
                    common.loading.hide();
                });
                
            }else{
                common.loading.show();
                orderRequest.getOrderInfo(collect.orderId)
                .then(function(data){
                    // console.log(data);
                    common.loading.hide();
                    collect.docInfo=data.docInfo;
                    
                    console.log(collect.docInfo);
                    initPages(collect.docInfo.docId,collect.docInfo.pageNum, collect.docInfo.fileName);
                },function(data){
                    common.loading.hide();
                })
            }
            
        }

        function initPages(docId,pageNum, filename){

            let path = constant.config.sitePDF + constant.config.pdf_previewPath + "/";

            if (collect.docInfo.fileName.endsWith("_image"))
            {
                path = constant.config.siteIMG + constant.config.pdf_previewPath + "/";
            }

            $("#myPDF").pdf( {
                title: collect.docInfo.fileName,
                disableZoom: true,
                disableLinks: true,
                disableKeys	: true,
                source: path+docId,
            } );
        }

        function previousPage(){
            collect.swiper.swipePrev();
        }
        function nextPage(){
            if(collect.swiper.activeIndex<collect.docInfo.pageNum-1){

                collect.swiper.swipeNext();
            }
        }
        function onPageChanged(swiper){
            // console.log(swiper.activeIndex);
        }
    }
    
}